import { render } from "./AppCheckbox.vue?vue&type=template&id=49453e15&scoped=true&ts=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=ts"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts"

import "./AppCheckbox.vue?vue&type=style&index=0&id=49453e15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49453e15"]])

export default __exports__